/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingnotfound2Inputs */

const en_listingnotfound2 = /** @type {(inputs: Listingnotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Not Found`)
};

const de_listingnotfound2 = /** @type {(inputs: Listingnotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort nicht gefunden`)
};

/**
* | output |
* | --- |
* | "Listing Not Found" |
*
* @param {Listingnotfound2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingnotfound2 = /** @type {((inputs?: Listingnotfound2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingnotfound2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingnotfound2(inputs)
	return de_listingnotfound2(inputs)
});
export { listingnotfound2 as "listingNotFound" }